type EMTemplateData = any;
type SPTemplateData = any;
type VMTemplateData = any;

export enum Channel {
  EMAIL_MARKETING = 'EMAIL_MARKETING',
  SOCIAL_POSTS = 'SOCIAL_POSTS',
  VIDEO_MAKER = 'VIDEO_MAKER',
}

export type ChannelTemplateData =
  | EMTemplateData
  | SPTemplateData
  | VMTemplateData;

export type ChannelsPermitted = Record<Channel, boolean>;

export type PromotionTemplates = {
  intentType: string;
  itemId: string;
  channels: Partial<Record<Channel, ChannelTemplateData[]>>;
};
